import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ModuleHeader from "../../components/moduleHeader";
import Footer from "../../components/footer";
import { getProfile } from "../../services/api";
import Notiflix from "notiflix";

function Support() {
  const navigate = useNavigate();
  const { id: uuid } = useParams();
  const [formData, setFormData] = useState({
    subject: "",
    message: ""
  });
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState(null);
  const [isHeaderExpanded, setIsHeaderExpanded] = useState(false);

  useEffect(() => {
    Notiflix.Notify.init({
      position: "top-right",
      timeout: 3000,
      clickToClose: true,
      pauseOnHover: true,
    });
  }, []);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await getProfile();
        setUserData(response);
      } catch (error) {
        console.error("Profil verisi alınamadı:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Form validasyonu
    if (!formData.subject || !formData.message) {
      Notiflix.Notify.warning("Lütfen konu ve mesaj alanlarını doldurun");
      return;
    }

    try {
      // TODO: API çağrısı buraya eklenecek
      // await submitSupportRequest({ subject: formData.subject, message: formData.message });
      
      Notiflix.Notify.success("Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapılacaktır.");
      
      // Formu temizle
      setFormData({
        subject: "",
        message: ""
      });
    } catch (error) {
      Notiflix.Notify.failure("Bir hata oluştu. Lütfen tekrar deneyin.");
    }
  };

  // Loading durumunda loading ekranı göster
  if (loading || !userData) {
    return (
      <div className="w-full h-screen min-h-screen flex items-center justify-center bg-[#fff]">
        <div className="flex flex-col items-center justify-center">
          <div className="relative mb-8">
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="animate-spin rounded-full h-24 w-24 border-4 border-transparent border-t-[#3DA7B5] border-r-[#3DA7B5] opacity-75"></div>
            </div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div
                className="animate-spin rounded-full h-16 w-16 border-[3px] border-transparent border-b-[#2a8a96] border-l-[#2a8a96] opacity-60"
                style={{
                  animationDirection: "reverse",
                  animationDuration: "1.5s",
                }}
              ></div>
            </div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="h-12 w-12 rounded-full bg-gradient-to-br from-[#3DA7B5] via-[#2a8a96] to-[#3DA7B5] animate-pulse shadow-2xl"></div>
            </div>
          </div>
          <p className="text-xl font-semibold text-gray-800 animate-pulse">
            Yükleniyor...
          </p>
        </div>
      </div>
    );
  }

  const fullName = userData?.user ? `${userData.user.first_name} ${userData.user.last_name}` : "";

  return (
    <div className="w-full h-screen min-h-screen flex items-stretch justify-stretch sm:items-center sm:justify-center bg-[#e8e9ed] relative">
      <div className="flex flex-col items-center w-full min-h-full bg-white shadow-xl border border-gray-200 rounded-none sm:max-w-[390px] sm:h-[700px] sm:rounded-3xl relative overflow-y-auto">
        {/* ModuleHeader */}
        <div className="relative z-30 w-full mb-2">
          <ModuleHeader
            userName={fullName}
            subtitle="Destek Modülüne Hoş Geldiniz"
            title="Destek"
            description="Size nasıl yardımcı olabiliriz? Sorunlarınızı veya taleplerinizi bizimle paylaşın."
            backgroundImage="/assets/settings.jpg"
            onExpandedChange={setIsHeaderExpanded}
            showToggle={true}
            autoHeight={true}
          />
        </div>

        {/* Form */}
        <div className="w-full px-6 pb-20 flex-1">
          <form onSubmit={handleSubmit} className="space-y-6 pt-4">
            {/* Konu */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Konu *
              </label>
              <select
                name="subject"
                value={formData.subject}
                onChange={handleInputChange}
                className="w-full px-4 py-3.5 border-2 border-gray-200 rounded-xl bg-white focus:ring-2 focus:ring-[#3DA7B5] focus:border-[#3DA7B5] outline-none transition-all duration-200 text-gray-700 font-medium"
              >
                <option value="">Konu seçin</option>
                <option value="teknik-sorun">Teknik Sorun</option>
                <option value="uygulama-hatasi">Uygulama Hatası</option>
                <option value="ozellik-talebi">Özellik Talebi</option>
                <option value="hesap-sorunu">Hesap Sorunu</option>
                <option value="geri-bildirim">Geri Bildirim</option>
                <option value="diger">Diğer</option>
              </select>
            </div>

            {/* Mesaj */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Mesajınız *
              </label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                rows={6}
                className="w-full px-4 py-3.5 border-2 border-gray-200 rounded-xl bg-white focus:ring-2 focus:ring-[#3DA7B5] focus:border-[#3DA7B5] outline-none resize-none transition-all duration-200 text-gray-700 placeholder-gray-400"
                placeholder="Sorununuzu veya talebinizi detaylı bir şekilde açıklayın..."
              />
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full bg-gradient-to-r from-[#3DA7B5] to-[#2a8a96] hover:from-[#2a8a96] hover:to-[#3DA7B5] text-white font-semibold py-4 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98] mt-8"
            >
              Gönder
            </button>
          </form>
        </div>

        <Footer uuid={uuid} />
      </div>
    </div>
  );
}

export default Support;
